export const trackMapConfig = {
    maxFileDropComplexity: 2000,
    maxResourcesInList: 1000,
};
